var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./NotFound.less');

var CommonSearchInput = require('front/components/CommonSearchInput/CommonSearchInput');

module.exports = Section.extend({

    el: '.NotFound',

    events: {
    },


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonSearchInput': {selector: '.CommonSearchInput', viewConstructor: CommonSearchInput}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onInputEnterPressed');

        Section.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Section.prototype.viewsRegistration.call(this);

        this.searchInput = this.getView('CommonSearchInput');

        this.searchInput.on('enter-pressed', this.onInputEnterPressed);
    },


    deactivate: function (params) {

        this.searchInput.off('enter-pressed', this.onInputEnterPressed);

        return Section.prototype.deactivate.call(this, params);
    },


    onInputEnterPressed: function (query) {
        Backbone.history.navigate(app.composeSearchUrl(query, 1, 'all'), {trigger: 'true'});
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/NotFound/NotFound.js
// module id = 286
// module chunks = 0